import React, { useState,useEffect } from 'react';
import './TestimonialSlider.css';
import vinod from "./Images/vinod.jpeg";
import sudeep from "./Images/sudeep.jpeg";
import rushikesh from "./Images/rushikesh.jpeg";
const testimonials = [
    {
        text: "We placed our first trial order for lactic acid and hydrogenated oils through Global Link. The delivery was well-managed and they supported us with all required documents on time. It’s rare to find suppliers who stay so involved even after the shipment is done.",
        name: "Vinod Chaudhary",
        role: "Global Procurement Head, Prime Care",
        image: vinod , // Replace if you want custom
        rating: 5,
    },
    {
        text: "I really appreciate how approachable and professional their team is. When we had some confusion with product grades and COA approvals, they patiently helped us sort everything out. Looking forward to more orders with them.",
        name: "Sudeep Gupta",
        role: "Buisness Development Manager,Laxmi International",
        image:  sudeep , // Replace with team member's photo if available
        rating: 5,
    },
    {
        text: "Great support on both technical and commercial fronts. We sourced PEGs and Polysorbates and were happy with both the product quality and the coordination. Keep it up!",
        name: "Rushikesh Rajput",
        role: "Sales Manager, Unicure Pvt Ltd",
        image: rushikesh , // Replace if you want custom
        rating: 5,
    }
];
  

const TestimonialSlider = () => {
    const [index, setIndex] = useState(0);
  

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
        }, 5000); // Change every 5 seconds

        return () => clearInterval(interval); // Clean up
    }, []);
    



    return (
        <section className="testimonial-section">
            <div className="testimonial-container">
                <h2 className="testimonial-title">What Our Clients Say</h2>
                <p className="testimonial-subtitle">Trusted by leading companies across various industries</p>

                <div className="testimonial-card-wrapper">
                    <div className="testimonial-card">
                        <div className="quote-icon">❝</div>
                        <p className="testimonial-text">{testimonials[index].text}</p>

                        <div className="testimonial-profile">
                            <img src={testimonials[index].image} alt={testimonials[index].name} className="profile-image" />
                            <div>
                                <h4 className="testimonial-name">{testimonials[index].name}</h4>
                                <p className="testimonial-role">{testimonials[index].role}</p>
                            </div>
                        </div>

                        <div className="testimonial-rating">
                            {[...Array(5)].map((_, i) => (
                                <span key={i} className={`star ${i < testimonials[index].rating ? 'filled' : 'empty'}`}>★</span>
                            ))}
                        </div>
                    </div>

                    <div className="testimonial-dots">
                        {testimonials.map((_, i) => (
                            <button key={i} onClick={() => setIndex(i)} className={`dotReview ${index === i ? 'active' : ''}`} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialSlider;
